/* Copyright 2023 VMware, Inc. All rights reserved. VMware Confidential */

import { Component, Input, Output } from "@angular/core";
import { Subject } from "rxjs";

//@formatter:off
@Component({
    selector: 'global-error',
    templateUrl: 'global-error.component.html',
    styleUrls: ['global-error.component.scss']
})
//@formatter:on
export class GlobalErrorComponent {

    @Input()
    errorMsg: string;

    @Input()
    errorBtn: string;

    @Input()
    closable: boolean = false;

    @Output()
    errorBtnClick: Subject<void> = new Subject<void>();

    onErrorButtonClick(): void {
        this.errorBtnClick.next();
    }
}
